<div class="accept-mobile-wrapper" fxLayout="column">
  <div class="accept-header" fxLayout="row">
    <h3>{{ 'ACCEPT_TERMS.MUST_ACCEPT_TERMS' | translate }}</h3>
  </div>
  <div class="terms-area" fxLayout="row">
    <mat-form-field fxFlex>
        <textarea matInput readonly name="" id="" rows="10"  style="width: 100%">
       {{termsText}}
     </textarea>
    </mat-form-field>

  </div>
  <div class="actions" fxLayout="row" fxLayoutAlign="space-around">
    <button mat-raised-button color="primary" (click)="approve()">{{ 'ACCEPT_TERMS.APPROVE_TERMS' | translate }}</button>
    <button mat-raised-button color="danger" (click)="close()">{{ 'COMMON.CLOSE' | translate }}</button>
  </div>

</div>
